"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsEnabled_1 = require("./prebindHelpers/AnalyticsEnabled");
var CoveoForSitecoreAnalyticsEndpoint_1 = require("./prebindHelpers/CoveoForSitecoreAnalyticsEndpoint");
var CurrentPageName_1 = require("./prebindHelpers/CurrentPageName");
var FieldTranslator_1 = require("./prebindHelpers/FieldTranslator");
var IsAnonymous_1 = require("./prebindHelpers/IsAnonymous");
var MainSearchInterfaceSelector_1 = require("./prebindHelpers/MainSearchInterfaceSelector");
var SortCriteria_1 = require("./prebindHelpers/SortCriteria");
var UnfoldDictionaryToAttributes_1 = require("./prebindHelpers/UnfoldDictionaryToAttributes");
var PrebindHelpers = (function () {
    function PrebindHelpers() {
    }
    PrebindHelpers.getAllPrebindHelpers = function () {
        return [
            new AnalyticsEnabled_1.AnalyticsEnabledPrebind(),
            new CoveoForSitecoreAnalyticsEndpoint_1.CoveoForSitecoreAnalyticsEndpointPrebind(),
            new CurrentPageName_1.CurrentPageNamePrebind(),
            new FieldTranslator_1.FieldTranslatorPrebind(),
            new IsAnonymous_1.IsAnonymousPrebind(),
            new MainSearchInterfaceSelector_1.MainSearchInterfaceSelectorPrebind(),
            new SortCriteria_1.SortCriteriaPrebind(),
            new UnfoldDictionaryToAttributes_1.UnfoldDictionaryToAttributesPrebind(),
        ];
    };
    return PrebindHelpers;
}());
exports.PrebindHelpers = PrebindHelpers;



//////////////////
// WEBPACK FOOTER
// ./src/resolvers/prebinding/PrebindHelpers.ts
// module id = 35
// module chunks = 13 14